import React, { lazy } from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
const Form = lazy(() =>
  import("@/pages/forms/MyComponent")
);

const Forms = [
  {
    path: "form",
    element: (
      <SuspenseWrapper>
       <Form/>
      </SuspenseWrapper>
    ),
    children: [
    
    ],
  },
];

export default Forms;
